import React from "react";
import { useSelector } from "react-redux";
import { Geographies, GeographyProps } from "react-simple-maps";
import { RootState } from "../../../../store/store";
import { GeoMap } from "./GeoMap";

const GeoMapContainer: React.FC = () => {
  const { data: geography } = useSelector((state: RootState) => state.mapApi);
  const {
    countriesPerUser: { data: countries },
  } = useSelector((state: RootState) => state);

  if (!geography || !countries) {
    return null;
  }

  const renderGeoMap = (geographies: GeographyProps[]) => {
    return <GeoMap geographies={geographies} />;
  };

  return (
    <Geographies geography={geography}>
      {({ geographies }) => renderGeoMap(geographies)}
    </Geographies>
  );
};

export default GeoMapContainer;
